import type { TagDesignTokens, TagTokenSections } from '@primeuix/themes/types/tag';

// Rebrand 2026 (DS): tag = the "badge" pill — tinted background, ink-coloured label.
export const root: TagTokenSections.Root = {
    fontSize: '0.75rem',
    fontWeight: '600',
    padding: '4px 11px',
    gap: '6px',
    borderRadius: '{extend.borderRadius.rounded}',
    roundedBorderRadius: '{extend.borderRadius.rounded}'
};

export const icon: TagTokenSections.Icon = {
    size: '0.75rem'
};

export const colorScheme: TagTokenSections.ColorScheme = {
    light: {
        primary: {
            background: '{primary.100}',
            color: '{primary.600}'
        },
        secondary: {
            background: '{grey.100}',
            color: '{grey.600}'
        },
        success: {
            background: '{green.100}',
            color: '{green.500}'
        },
        info: {
            background: '{blue.100}',
            color: '{blue.600}'
        },
        warn: {
            background: '{yellow.200}',
            color: '{yellow.700}'
        },
        danger: {
            background: '{extend.stateerrorbg}',
            color: '{wine.900}'
        },
        contrast: {
            background: '{sand.950}',
            color: '{surface.0}'
        }
    },
    dark: {
        primary: {
            background: 'color-mix(in srgb, {primary.500} 18%, transparent)',
            color: '{primary.200}'
        },
        secondary: {
            background: '{surface.800}',
            color: '{surface.300}'
        },
        success: {
            background: 'rgba(46, 139, 87, 0.22)',
            color: '{green.300}'
        },
        info: {
            background: 'rgba(43, 127, 209, 0.22)',
            color: '{blue.300}'
        },
        warn: {
            background: 'rgba(255, 210, 74, 0.22)',
            color: '{yellow.300}'
        },
        danger: {
            background: 'rgba(194, 142, 157, 0.22)',
            color: '{wine.300}'
        },
        contrast: {
            background: '{surface.0}',
            color: '{surface.950}'
        }
    }
};

export default {
    root,
    icon,
    colorScheme
} satisfies TagDesignTokens;
